export interface IDeviceTokensAddDeviceTokenCommand {
    deviceToken?: string | undefined;
}

export class DeviceTokensAddDeviceTokenCommand implements IDeviceTokensAddDeviceTokenCommand {
    deviceToken?: string | undefined;

    constructor(data?: IDeviceTokensAddDeviceTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }
}